import { Box } from '@mui/material';
import * as React from 'react';
import { DeviceType } from '../orbit-context';

interface TabPanelProps<T> {
  value: T;
  id: T;
  children: React.ReactNode;
}

export default function TabPanel<T> (props: TabPanelProps<T>) {
  const deviceType = React.useContext(DeviceType);

  const { value, id, children } = props;
 
  return (
    <Box style={{display:value === id?'block':'none',flexGrow:deviceType==='computer'?1:'unset',overflowX:deviceType==='computer'?'auto':'auto',overflowY:deviceType==='computer'?'auto':'clip',width:'100%'}}>
      { children }
    </Box>
  );
}



